<template>
  <div class="flex-1 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
    <div class="sm:mx-auto sm:w-full sm:max-w-md">
      <app-logo/>
      <h2 class="text-center text-3xl leading-9 font-extrabold text-gray-900">
        {{$t('resetPassword.title')}}
      </h2>
    </div>

    <div class="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
      <div class="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
        <form @submit.prevent="submit">
          <div>
            <label for="password" class="block text-sm font-medium leading-5 text-gray-700">
              {{$t('resetPassword.placeholders.password')}}
            </label>
            <div class="mt-1 rounded-md">
              <fg-input v-model="form.password"
                        type="password"
                        ref="password"
                        addon-left-icon="nc-icon nc-key-25"
                        id="password"
                        v-validate="modelValidations.password"
                        :name="$t('resetPassword.placeholders.password')"
                        :error="getError($t('resetPassword.placeholders.password'))"
                        :placeholder="$t('resetPassword.placeholders.password')">
              </fg-input>
            </div>
          </div>

          <div class="mt-2">
            <label for="confirm-password" class="block text-sm font-medium leading-5 text-gray-700">
              {{$t('resetPassword.placeholders.password')}}
            </label>
            <div class="mt-1 rounded-md">
              <fg-input v-model="form.password_confirmation"
                        addon-left-icon="nc-icon nc-key-25"
                        id="confirm-password"
                        v-validate="modelValidations.password_confirmation"
                        :name="$t('resetPassword.placeholders.confirmPassword')"
                        :placeholder="$t('resetPassword.placeholders.confirmPassword')"
                        :error="getError($t('resetPassword.placeholders.confirmPassword'))"
                        type="password"></fg-input>
            </div>
          </div>

          <div class="mt-6">
            <span class="block w-full rounded-md shadow-sm">
              <base-button type="default"
                           native-type="submit"
                           :loading="loading"
                           block
                           class="mb-3">
                {{$t('login.submit')}}
              </base-button>
            </span>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
  import { Card } from 'src/components'
  import AppNavbar from './layout/AppNavbar'
  import AppFooter from './layout/AppFooter'
  import AuthService from 'src/services/AuthService'
  import AppLogo from './AppLogo'

  export default {
    components: {
      Card,
      AppNavbar,
      AppFooter,
      AppLogo
    },
    data () {
      return {
        loading: false,
        form: {
          password: '',
          password_confirmation: '',
          token: this.$route.query.token
        },
        modelValidations: {
          password: {
            required: true,
            min: 6
          },
          password_confirmation: {
            required: true,
            min: 6,
            confirmed: 'password',
          }
        }
      }
    },
    methods: {
      async submit () {
        let result = await this.$validator.validateAll()
        if (!result) return
        try {
          this.loading = true
          await AuthService.resetPassword(this.form)
          this.$notify({
            type: 'success',
            message: this.$t('resetPassword.successMessage')
          })
          this.$router.push({name: 'login'})
        } catch (e) {
          console.warn(e)
        } finally {
          this.loading = false
        }
      }
    }
  }
</script>
<style>
</style>
